@import (reference) '../../constants/spacing.module.less';

.drawer {
  max-width: 1400px;
  margin: auto;
}

.drawer-content {
  padding: @space-48 @space-64;
  display: flex;
  flex-direction: column;
  gap: @space-24;
  overflow-y: overlay;
}

.instruction-text {
  margin-top: @space-24;
  font-weight: 500;
}

.early-access-tag {
  display: flex;
  align-items: center;
  padding: @space-0 @space-8;
  margin-left: @space-8;
  color: var(--white);
  font-weight: 500;
  border-radius: 16px;
  background: #0f0f10;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-16 @space-24;
}

.feedback-link {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: @space-4;
  font-size: 12px;
  color: var(--blue-006FBB);
  .icon {
    width: 16px;
    height: 16px;
  }
}

.form-container {
  display: flex;
  margin-top: @space-16;
}

.form-left-column {
  flex: 1;
  padding-right: @space-24;
  border-right: 1px solid var(--gray-AFB3B6);
}

.select-warehouse-text {
  margin-top: @space-16;
}

.add-product-text {
  margin-top: @space-16;
}

.form-right-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: @space-24;
}

.xmark-icon {
  width: 10px;
  height: 10px;
  margin-right: @space-4;
}

.optional-text {
  font-size: 12px;
  color: var(--grey-600);
  margin-left: 2px;
}

.drawer-section {
  background-color: var(--white);
  border-radius: @space-8;
  border: 1px solid var(--grey-300);
  padding: @space-16;
  width: 100%;
  height: auto;
  min-height: fit-content;
  @media screen and (max-width: 500px) {
    overflow: auto;
  }
}

.promotional-banner {
  padding: 6px @space-16;
  border-radius: 4px;
}

.toggle-advanced-fields {
  align-items: center;
  margin-left: auto;
  color: var(--grey-900);
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: @space-16;
  padding: @space-16 @space-32;
  border-top: 1px solid var(--grey-300);
  margin-top: auto;
}

.text-row {
  display: flex;
  justify-content: flex-start;
  margin: @space-8 @space-0 @space-16 @space-0;
}

.description {
  margin-bottom: @space-8;
}
